import styled, {css} from 'styled-components';

import {getAlphaColor, getColor, getRem, gts, ms} from '../../../../styles';
import {Button} from '../../../../uikit/Button';
import {Text} from '../../../../uikit/Text';

export const Container = styled(Button)<{
  disabled: boolean;
  isHidden?: boolean;
  isSelected: boolean;
}>`
  flex: 1 1 calc(25% - ${ms(8)});
  padding-inline: ${gts('padding.xs')};

  ${p =>
    !p.isSelected &&
    !p.disabled &&
    css`
      background-color: ${getAlphaColor('button.secondary', 0.1)};

      &:hover {
        background-color: ${getAlphaColor('button.secondary', 0.2)};
      }
    `}

  ${p =>
    p.isHidden &&
    css`
      height: 0;
      pointer-events: none;
      opacity: 0;
      margin-block-start: -${gts('gap.sm')};
    `}
`;

export const Label = styled(Text)<{isDisabled: boolean; isSelected: boolean}>`
  color: ${p =>
    p.isSelected || p.isDisabled ? 'inherit' : getColor('text.secondary')(p)};

  @media screen and (max-width: 375px) {
    font-size: ${getRem(12)};
  }
`;
